import React from 'react';
import { Box, Grid, Stack } from '@mui/material';
import { baseColors } from '../../../Themes/colors';
import ApplicationHeader from './ApplicationHeader';
import ApplicationMetrics from './ApplicationMetrics';
import CommonTab from '../../../components/tabComponent/CommonTab';
var ApplicationDetailsPanel = function (_a) {
    var applicationId = _a.applicationId, customerName = _a.customerName, customerCode = _a.customerCode, avatarUrl = _a.avatarUrl, onScrollCapture = _a.onScrollCapture, statusSteps = _a.statusSteps, metrics = _a.metrics, tabs = _a.tabs, documentPreviewPanel = _a.documentPreviewPanel, rightPanel = _a.rightPanel, _b = _a.isRightPanelCompact, isRightPanelCompact = _b === void 0 ? false : _b, _c = _a.fillParentHeight, fillParentHeight = _c === void 0 ? false : _c, activeIndex = _a.activeIndex, onBack = _a.onBack, onTabChange = _a.onTabChange;
    var hasRightPanel = Boolean(rightPanel);
    var hasDocumentPreview = Boolean(documentPreviewPanel);
    var leftPanelColumns = 12;
    var rightPanelColumns = 3;
    if (hasRightPanel) {
        if (hasDocumentPreview && isRightPanelCompact) {
            leftPanelColumns = 11;
            rightPanelColumns = 1;
        }
        else {
            leftPanelColumns = 9;
            rightPanelColumns = 3;
        }
    }
    var gridSpacing = isRightPanelCompact ? 0.5 : 2;
    var columnHeightLg = fillParentHeight ? '100%' : 'calc(100vh - 97px)';
    return (React.createElement(Stack, { sx: {
            width: '100%',
            height: '100%',
            minHeight: 0,
            overflow: 'hidden',
        }, onScrollCapture: onScrollCapture },
        React.createElement(Stack, { direction: { xs: 'column', lg: 'row' }, sx: {
                bgcolor: baseColors.fullWhite,
                alignItems: { xs: 'flex-start', lg: 'center' },
                justifyContent: 'space-between',
                gap: { xs: 1.5, lg: 0 },
                px: { xs: 2, md: 2 },
                py: { xs: 1, md: 0.8 },
                position: 'sticky',
                top: 0,
                zIndex: 12,
                boxShadow: 'none',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                overflow: 'hidden',
            } },
            React.createElement(ApplicationHeader, { applicationId: applicationId, customerName: customerName, customerCode: customerCode, avatarUrl: avatarUrl, onBack: onBack, statusSteps: statusSteps }),
            React.createElement(Box, null,
                React.createElement(ApplicationMetrics, { metrics: metrics }))),
        React.createElement(Stack, { sx: {
                pl: 3,
                pb: 0,
                pr: 0,
                overflowX: 'hidden',
                flex: 1,
                minHeight: 0,
                overflowY: { xs: 'auto', lg: 'hidden' },
            } },
            React.createElement(Grid, { container: true, spacing: gridSpacing, sx: { alignItems: 'flex-start', width: isRightPanelCompact ? "calc(100% + 60px)" : 'auto', height: fillParentHeight ? { xs: 'auto', lg: "calc(100% + ".concat(gridSpacing * 8, "px)") } : undefined } },
                React.createElement(Grid, { item: true, xs: 12, lg: leftPanelColumns, sx: {
                        transition: 'all 0.3s ease',
                        height: { xs: 'auto', lg: columnHeightLg },
                        minHeight: { xs: 'auto', lg: fillParentHeight ? 0 : columnHeightLg },
                        overflow: { xs: 'visible', lg: 'hidden' },
                        pt: { xs: 2, lg: 2 },
                    } },
                    React.createElement(CommonTab, { tabs: tabs, activeIndex: activeIndex, onTabChange: onTabChange, inlinePreviewPanel: documentPreviewPanel, isFromApplicationDetailPanel: true })),
                hasRightPanel ? (React.createElement(Grid, { item: true, xs: 12, lg: rightPanelColumns, sx: {
                        transition: 'all 0.3s ease',
                        height: { xs: 'auto', lg: columnHeightLg },
                        maxWidth: isRightPanelCompact ? { lg: '56px' } : 'auto',
                        width: isRightPanelCompact ? { lg: '56px' } : 'auto',
                        overflow: 'hidden',
                    } },
                    React.createElement(Box, { sx: {
                            height: '100%',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease',
                            width: '100%',
                        } }, rightPanel))) : null))));
};
export default ApplicationDetailsPanel;
